import { useSelector } from 'react-redux';
import { CreditConsent } from '@makemydeal/dr-shared-components';
import { useCustomerCardContext } from '../../CustomerFormContext';
import { getBuyer, getBuyerDraft, getCoBuyer, getCoBuyerDraft } from '../../../store/selectors';
import { CUSTOMER_TABS } from '../../../types/CustomerCardTypes';
import type { CustomerCardStoreState } from '../../../types/CustomerCardTypes';
import { CUSTOMER_CARD_ANALYTICS } from '../../../analytics';

/**
 * Binds the shared `CreditConsent` box to this card's validation engine. The shared component is
 * store-free so the legacy card can bind it to offer-redux instead.
 */
const CreditConsentSection = () => {
    const { formValues, handleCreditConsentChange, isLocked, customerRole, onAnalyticsEvent } = useCustomerCardContext();

    const isCoBuyer = customerRole === CUSTOMER_TABS.CO_BUYER;
    const storedParticipant = useSelector((state: CustomerCardStoreState) => (isCoBuyer ? getCoBuyer(state) : getBuyer(state)));
    const draftedParticipant = useSelector((state: CustomerCardStoreState) =>
        isCoBuyer ? getCoBuyerDraft(state) : getBuyerDraft(state)
    );

    // Consent cannot be revoked, so once it is on file the box is shown checked but disabled. It is held
    // per participant, so a draft answers for the person it replaces rather than inheriting their lock.
    const isConsentGiven = Boolean((draftedParticipant ?? storedParticipant)?.creditPullConsentGiven);

    const handleChange = (checked: boolean) => {
        handleCreditConsentChange(checked);
        onAnalyticsEvent?.(CUSTOMER_CARD_ANALYTICS.CREDIT_CONSENT_CLICKED, { checked, role: customerRole });
    };

    return (
        <CreditConsent
            idPrefix={customerRole}
            checked={Boolean(formValues.creditPullConsentGiven)}
            onChange={handleChange}
            disabled={isLocked || isConsentGiven}
        />
    );
};

export default CreditConsentSection;
